__webpack_require__.p = "/sisense-embedsdk-react-sampleapp/";